import React, {useEffect, useState} from 'react';

const FakeProgressLoader: React.FC<{completed: boolean}> = ({completed}) => {
    const [progress, setProgress] = useState<number>(0);

    function getRandomPausingPoint(): number {
        return Math.floor(Math.random() * 9) + 89;
    }

    useEffect(() => {
        if (completed) {
            setProgress(100);
        } else {
            const startTime = Date.now();
            const endTime = startTime + 5000; // 5 seconds duration
            const pausingPoint = getRandomPausingPoint();
            const interval = setInterval(() => {
                const now = Date.now();
                const remainingTime = Math.max(0, endTime - now);
                const fakeProgress = Math.min(100 - (remainingTime / 5000) * 100, pausingPoint);
                if (fakeProgress >= 70 && fakeProgress <= 89) {
                    setProgress(70);
                } else {
                    setProgress(fakeProgress);
                }
                if (now >= endTime) {
                    clearInterval(interval);
                }
            }, 50);

            return () => clearInterval(interval);
        }
    }, [completed]);

    return (
        <div className='relative size-[80px]'>
            <svg className='size-full' width='36' height='36' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'>
                {/* Background Circle */}
                <circle
                    cx='18'
                    cy='18'
                    r='16'
                    fill='none'
                    className='stroke-current text-[#3E4784] dark:text-green-600'
                    strokeWidth='3'></circle>
                {/* Progress Circle inside a group with rotation */}
                <g className='origin-center -rotate-90 transform'>
                    <circle
                        cx='18'
                        cy='18'
                        r='16'
                        fill='none'
                        className='stroke-current text-white'
                        strokeWidth='3'
                        strokeDasharray='100'
                        strokeDashoffset={progress}></circle>
                </g>
            </svg>
            {/* Percentage Text */}
            <div className='absolute start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform'>
                <span className='text-center text-[14px]'>{Math.round(progress)}%</span>
            </div>
        </div>
    );
};

export default FakeProgressLoader;
